import React, { Component, Dispatch } from 'react';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import { Log } from 'ng2-logger';
import FileUpload from '../../../components/file-upload/main';
import { IActivityCard, IActivityCardItems } from '../../../models/components/activity-card';
import * as Actions from '../../../store/actions/assignment';
import Translator from '../../../core/i18n';
import { IEnrollmentData } from '../../../models/action/enrollment';
import { Notification } from '../../../components/notification/main';
import { Guid } from 'guid-typescript';
import { ActivityTypeEnums } from '../../../models/enums/ActivityType';
import { CoursePageService } from '../../../api/course-page-service';
import { CourseContentMenuType } from '../../../models/enums/CourseContentMenuType';
import { ICourseContentWeekActivitesBody } from '../../../models/components/course-content-weekactivities';
import { CourseDefaultViewType } from '../../../models/enums/CourseDefaultViewType';
import { Button } from '../../../components/ui-elements/main';

const coursePageService = new CoursePageService();

interface ISendAssignmentProps {
    activityCard?: Array<IActivityCardItems>;
    enrollmentData?: Array<IEnrollmentData>;
    classId?: any;
    callBackFunction?: any;
    dispatch?: any;
    assignmentActivityCard?: IActivityCardItems;
    fileControl?: any;
    coursePageActivityId?: string;
    weekOrUnitId?: string | null | undefined;
    courseContentMenuType?: CourseContentMenuType;
    courseContentTermWeeks?: Array<{
        notWeekly: boolean;
        notWeeklyName: string | null;
        termId: string | null;
        termWeekId: string | null;
        week: number | null;
        endDate: Date | null;
        startDate: Date | null;
        itemGuid: string;
        genaralActivity: boolean;
        status: number;
    }> | null;
    courseContentWeeksActivities?: Array<ICourseContentWeekActivitesBody>;
    sort?: string | null;
    coursePageClassId?: string;
    courseDefaultView?: CourseDefaultViewType | null;
}

interface ISendAssignmentState {
    isUploadedFile: boolean;
    isDisabled: boolean;
    nonWeeklyCourse: boolean | null | undefined;
    isExpanded: boolean;
    radioType: number;
    assignmentPostType: number;
    isMessageSent: boolean;
    isProccessing: boolean;
}

const _logger = Log.create('login.tsx');
let _common: Common;
let _fileInputkey: string = '';
const T = Translator.create();
class CSendAssignmentModal extends Component<ISendAssignmentProps, ISendAssignmentState> {
    delayTimer: any;
    public state: ISendAssignmentState = {
        isUploadedFile: false,
        isDisabled: true,
        nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1,
        isExpanded: false,
        radioType: 1,
        assignmentPostType: 0,
        isMessageSent: false,
        isProccessing: false
    };

    public componentDidMount(): void {
        this.props.fileControl(false)
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true });
        }
    }

    componentDidUpdate(prevProps: Readonly<ISendAssignmentProps>, prevState: Readonly<{}>, snapshot?: any): void {
        const nodeEnter = document.getElementsByClassName("textarea-counter mt-0")[0];
        if (nodeEnter) {

            nodeEnter.addEventListener("keyup", (event: any) => {
                if (event.key === "Enter" && !event.shiftKey) {
                    this.sendAssignment()
                }
            });
        }

        if (
            this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks &&
            this.props.courseContentTermWeeks &&
            this.props.courseContentTermWeeks.length === 1
        ) {
            this.setState({ nonWeeklyCourse: true });
        }
    }

    isFileExists = (isExists: boolean) => {
        this.props.fileControl(isExists)
        this.setState({ isUploadedFile: isExists });
        this.setState({ isDisabled: false });
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        _fileInputkey = Guid.create().toString();
    }

    isTextExists = () => {
        const answer: any = document.getElementById('answer');
        if (answer.value && answer.value.trim().length > 0) {
            this.setState({ isDisabled: false });
        }
    };

    public sendAssignment = () => {
        if (this.state.isMessageSent) {
            return;
        }

        this.setState({ isMessageSent: true, isDisabled: true, isProccessing: true }, () => {
            const answer: any = document.getElementById('answer');
            const { radioType, isUploadedFile } = this.state;
            const { enrollmentData, assignmentActivityCard, classId, callBackFunction, dispatch } = this.props;

            const showNotification = (type: string, message: string) => {
                Notification.setNotification(type == "info" ? "info" : "error", T.t(message), 'topRight');
                this.setState({ isMessageSent: false });
            };

            const sendAssignmentAction = (answerValue: string) => {
                const matchingElement = enrollmentData!.find(element => element.activityId === assignmentActivityCard!.activityId);
                if (matchingElement) {
                    dispatch(Actions.sendAssigmentGetAction(
                        {
                            Answer: answerValue,
                            FileUploadKey: _fileInputkey,
                            EnrollmentId: matchingElement.enrollmentId,
                            ActivityId: assignmentActivityCard!.activityId,
                            ClassId: classId
                        },
                        assignmentActivityCard!.enrollmentAssignmentUploadedCount,
                        this.callbackFunction
                    ));
                }
            };

            if (radioType === 2) {
                if (!answer.value && !isUploadedFile) {
                    showNotification('info', 'r_send_assignment_error');
                } else if (answer.value && isUploadedFile) {
                    showNotification('info', 'r_you_cannot_reply_when_upload_file');
                } else {
                    sendAssignmentAction(answer.value);
                }
            } else if (!isUploadedFile) {
                showNotification('info', 'r_send_assignment_error');
            } else {
                sendAssignmentAction('');
            }
        });
    };

    callbackFunction = () => {
        const { callBackFunction } = this.props;
        callBackFunction(true)
        this.setState({ isProccessing: false });
    }

    public render() {
        const allFileTypes = (window.appSettings.AssignmentFileUploadAllowedTypes ?? T.t('r_send_assignment_empty_supported_files'))
            .toLowerCase()
            .split(',')
            .filter((item, index, self) => self.indexOf(item) === index);

        const maxVisible = 8;
        const visibleFileTypes = this.state.isExpanded ? allFileTypes : allFileTypes.slice(0, maxVisible);
        const showMore = allFileTypes.length > maxVisible;
        return (
            <div className="assignment-lesson-card mt-3">
                {this.state.assignmentPostType == 0 ?

                    (<div>
                        <div className='grid-2 gap-1'>
                            <div  >
                                <div className='col-12 d-flex justify-content-center'>
                                    <img src={_common.GetDefaultImages('_assigment_upload')} style={{ width: '150px', height: '150px' }} />


                                </div>
                                <div className="col-md-12 d-flex justify-content-center">
                                    <div className="col-md-9 d-flex justify-content-center p-0">

                                        <div className="radio-tabs tick-radio position-relative">
                                            <input
                                                type="radio"
                                                name={'dateCriteria'}
                                                value={1}
                                                id="type-one"
                                                checked={(this.state.radioType === 1)}
                                                className="form-radio"
                                                style={{ borderRadius: 100 }}
                                                onChange={e => this.setState({ radioType: 1 })}

                                            />
                                            <label htmlFor="type-one" style={{ marginInlineStart: "6px" }}>{T.t('r_upload_file')}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div >
                                <div className='col-12 d-flex justify-content-center'>
                                    <img src={_common.GetDefaultImages('_assigment_text')} style={{ width: '150px', height: '150px' }} />

                                </div>
                                <div className="col-md-12 d-flex justify-content-center">
                                    <div className="col-md-9 d-flex justify-start-end p-0">

                                        <div className="radio-tabs tick-radio position-relative">
                                            <input
                                                type="radio"
                                                name={'dateCriteria'}
                                                value={2}
                                                checked={(this.state.radioType === 2)}
                                                id="type-two"
                                                className="form-radio"
                                                style={{ borderRadius: 100 }}
                                                onChange={e => this.setState({ radioType: 2 })}

                                            />
                                            <label htmlFor="type-two" style={{ marginInlineStart: "6px" }}>{T.t('r_write_text')}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-12 d-flex justify-content-end mt-4'>
                            <Button
                                button_type='primary'
                                size='medium'
                                style={{marginLeft: '10px'}}
                                iconPosition='right'
                                materialicon='arrow_forward'
                                text={T.t('r_continue_button')}
                                onClick={() => this.setState({ assignmentPostType: this.state.radioType })}
                            />
                        </div>
                    </div>)
                    : this.state.assignmentPostType == 2
                        ?
                        <div>
                            <textarea className="textarea-counter mt-0" onChange={this.isTextExists} defaultValue={''} id="answer" />
                            <div className="lesson-attached-files mb-4">
                                <span>{T.t('r_send_assignment_description')}</span>
                            </div>
                        </div>

                        :
                        <div>
                            <div className="upload-image text-center mb-1 custom-file-upload">
                                <FileUpload
                                    key={_fileInputkey}
                                    fileInputKey={_fileInputkey}
                                    height={400}
                                    maxFileSize={(this.props.assignmentActivityCard!.assignmentMaximumFileSize ?? 1024) * 1024 * 1024}
                                    maxSelectedFileCount={1}
                                    isFileExists={this.isFileExists}
                                    fileTypes={window.appSettings.AssignmentFileUploadAllowedTypes}
                                    activityType={ActivityTypeEnums.Assignment}
                                    type="assignment"
                                />
                            </div>
                            <div className="lesson-attached-files row mt-4">
                                <div className="d-flex flex-column col-6 gap-1 vr-line">
                                    <span style={{ textAlign: 'start', fontSize: '14px' }}>{T.t('r_send_assignment_warning')} </span>
                                    <span className='d-flex flex-column' style={{ textAlign: 'start', fontSize: '13px' }}>
                                        <b>
                                            {T.t('r_send_assignment_max').replace(
                                                '{0}',
                                                this.props.activityCard && this.props.activityCard.length > 0
                                                    ? this.props.assignmentActivityCard!.assignmentMaximumUploadCount
                                                    : '0'
                                            )}</b>
                                        <b>{T.t('r_send_assignment_one_file')}</b>
                                        <b>{T.t('r_max_file_size_x').replace(
                                            '{0}',
                                            this.props.activityCard && this.props.activityCard.length > 0
                                                ? (this.props.assignmentActivityCard!.assignmentMaximumFileSize ?? 1024)
                                                : '0'
                                        )}
                                        </b>
                                    </span>
                                </div>
                                {/* <div className="vr-line"></div> */}
                                <div className="d-flex flex-column gap-1 col-6 align-items-end">
                                    <span style={{ textAlign: 'start', fontSize: '13px' }}>
                                        <b>{T.t('r_send_assignment_supported_files')}</b>
                                        {visibleFileTypes.join(', ')}
                                        {showMore && !this.state.isExpanded && ' ...'}
                                    </span>
                                    {showMore && (
                                        <Button
                                            onClick={() => this.setState(prevState => ({ isExpanded: !prevState.isExpanded }))}
                                            button_type='secondary'
                                            size='small'
                                            style={{marginLeft: '10px',marginBottom: '10px'}}
                                            text={T.t(this.state.isExpanded ? 'r_gen_show_less' : 'r_gen_show_more')}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>


                }
                {(this.state.assignmentPostType > 0) &&
                    (<div className='col- 12 d-flex justify-content-end'>
                        <Button
                            button_type='primary'
                            size='medium'
                            style={{marginLeft: '10px'}}
                            iconPosition='left'
                            materialicon='done'
                            text={this.state.isProccessing ? T.t('r_gen_saving') : T.t('r_save_button')}
                            onClick={() => this.sendAssignment()}
                            disabled={this.state.radioType == 1 ? (!this.state.isUploadedFile || this.state.isProccessing) : this.state.isDisabled}
                        />
                    </div>)}

            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISendAssignmentProps): ISendAssignmentProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISendAssignmentProps = Object.assign({}, ownProps, {
        activityCard: state.coursePage.activityCard,
        enrollmentData: state.enrollment.enrollmentData,
        classId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        sort: state.coursePage.courseSortingKey,
        coursePageClassId: state.coursePage.coursePageClassId,
        courseDefaultView: state.coursePage.courseDefaultView
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.courseContentMenuType === prev.coursePage.courseContentMenuType &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.coursePage.actId === prev.coursePage.actId &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const SendAssignmentModal = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CSendAssignmentModal);

export default SendAssignmentModal;
